import CONFIG from '~config/env.js'
import localForage from 'localforage'

// Cache Instances

const localForageInstances = []
const getInstance = storeName => {
  if (!localForageInstances[storeName]) {
    localForageInstances[storeName] = localForage.createInstance({
      name: CONFIG.CACHE_NAME,
      storeName
    })
  }

  return localForageInstances[storeName]
}

const dropInstance = storeName => {
  delete localForageInstances[storeName]

  return localForage.dropInstance({
    name: CONFIG.CACHE_NAME,
    storeName
  })
}

export default {
  getInstance,
  dropInstance
}
